export const isBrowserNotificationSupported = (target = window) =>
  typeof target !== "undefined" && typeof target.Notification !== "undefined";

export const getBrowserNotificationPermission = (target = window) => {
  if (!isBrowserNotificationSupported(target)) {
    return "unsupported";
  }

  return target.Notification.permission;
};

export const canSendBrowserNotification = (target = window) =>
  isBrowserNotificationSupported(target) &&
  target.Notification.permission === "granted";

export const requestBrowserNotificationPermission = async (
  target = window
) => {
  if (!isBrowserNotificationSupported(target)) {
    return "unsupported";
  }

  if (target.Notification.permission !== "default") {
    return target.Notification.permission;
  }

  return target.Notification.requestPermission();
};

export const sendBrowserNotification = ({
  title,
  body,
  onClick,
  target = window,
}) => {
  if (!canSendBrowserNotification(target)) {
    return null;
  }

  const notification = new target.Notification(title, {
    body,
    icon: "/logo192.png",
    tag: title,
  });

  if (onClick) {
    notification.onclick = onClick;
  }

  return notification;
};
